import { render } from "./FactExpensesOverview.vue?vue&type=template&id=35ea0d00&scoped=true"
import script from "./FactExpensesOverview.vue?vue&type=script&lang=js"
export * from "./FactExpensesOverview.vue?vue&type=script&lang=js"

import "./FactExpensesOverview.vue?vue&type=style&index=0&id=35ea0d00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ea0d00"]])

export default __exports__